import React from 'react';
import Timestamp from './Timestamp';

const Section = ({ 
  id, 
  title, 
  children, 
  className = "", 
  showTimestamp = true,
  containerClassName = "" 
}) => {
  return (
    <section 
      id={id}
      className={`flex relative justify-center px-4 py-8 scroll-mt-16 ${className}`}
    >
      <div className={`flex flex-col w-full max-w-6xl h-full ${containerClassName}`}>
        {title && (
          <div className="mb-6">
            <h2 className="text-3xl font-bold sm:text-4xl">{title}</h2>
            {showTimestamp && <Timestamp />}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section; 